"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=cohort.type.js.map